// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5311":"e5394b85","6085":"d583e311"}[chunkId] || chunkId) + "." + {"1155":"23c6c0acc2bdcf0e","2685":"c000a5155de311e9","5311":"09774936015682cc","6085":"53d4e75fa3afc501","9148":"6bea78587234e0c2"}[chunkId] + ".js";
};